let dbPromise = null;

// One shared connection, opened on first use
const initializeDB = () => {
  if (!dbPromise) {
    dbPromise = new Promise((resolve, reject) => {
      const request = indexedDB.open("MakeMeA_DB", 1);

      request.onerror = function () {
        dbPromise = null;
        reject("IndexedDB access required to function properly");
      };

      request.onsuccess = function (event) {
        const db = event.target.result;
        // Let another tab upgrade or delete the database
        db.onversionchange = () => {
          db.close();
          dbPromise = null;
        };
        resolve(db);
      };

      request.onupgradeneeded = function (event) {
        const db = event.target.result;
        if (!db.objectStoreNames.contains("states")) {
          // "id" is our key path because it's guaranteed to be unique
          db.createObjectStore("states", { keyPath: "id" });
        }
      };
    });
  }
  return dbPromise;
};

// A plain copy of the state that IndexedDB can store, without debugging info
// Earlier versions' pictures are left out (they're megabytes each, and the saved make
// keeps them), so saving a page stays quick.
const prepareStateForStorage = (state) => {
  // eslint-disable-next-line no-unused-vars
  const { lastRequest, ...rest } = state;
  const result = rest.result;
  if (result && Array.isArray(result.versions)) {
    rest.result = {
      ...result,
      versions: result.versions.map((version, index) =>
        index === result.versionIndex || !version.image
          ? version
          : { ...version, image: "" }
      ),
    };
  }
  return JSON.parse(JSON.stringify(rest));
};

const deleteDB = async () => {
  if (dbPromise) {
    try {
      (await dbPromise).close();
    } catch {
      // Already closed or never opened
    }
    dbPromise = null;
  }
  return new Promise((resolve, reject) => {
    const request = indexedDB.deleteDatabase("MakeMeA_DB");
    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
    request.onblocked = () => resolve();
  });
};

export { initializeDB, prepareStateForStorage, deleteDB };
